import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import KanbanColumn from './KanbanColumn';

const useStyles = makeStyles(theme => ({
  board: {
    display: 'flex',
    overflowX: 'auto',
    ...(theme.scrollbarStylesNeutral || theme.scrollbarStyles),
    padding: theme.spacing(1),
    height: '100%',
  },
}));

const KanbanBoard = ({ lanes, onCardMove, onLaneReorder, updateTicket, isAdmin, boardId, handleOpenTagMenu, laneTotals, lanePagination, fetchMoreTickets, currency = "$", onValueChange }) => {
  const classes = useStyles();

  const handleDragEnd = result => {
    if (!result.destination) return;

    const { source, destination, draggableId, type } = result;

    // Se for reordenação de lane
    if (type === 'LANE') {
      if (source.index !== destination.index) {
        onLaneReorder(source.index, destination.index);
      }
      return;
    }

    // Se for movimentação de card
    if (
      source.droppableId !== destination.droppableId ||
      source.index !== destination.index
    ) {
      onCardMove(
        draggableId,
        destination.droppableId,
        source.droppableId,
        source.index,
        destination.index
      );
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lanes" direction="horizontal" type="LANE">
        {(provided, snapshot) => (
          <div
            className={classes.board}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {lanes.map((lane, index) => (
              <KanbanColumn
                key={lane.id}
                id={lane.id}
                title={lane.title}
                tickets={lane.tickets}
                color={lane.color}
                index={index}
                updateTicket={updateTicket}
                isAdmin={isAdmin}
                laneTags={lane.laneTags}
                boardId={boardId}
                boardLanes={lanes}
                handleOpenTagMenu={handleOpenTagMenu}
                laneTotals={laneTotals}
                lanePagination={lanePagination}
                fetchMoreTickets={fetchMoreTickets}
                sendGreetingMessage={lane.sendGreetingMessage}
                greetingMessageLane={lane.greetingMessageLane}
                kanbanMessageDelay={lane.kanbanMessageDelay}
                kanbanMessageDelayUnit={lane.kanbanMessageDelayUnit}
                greetingMessageKanban={lane.greetingMessageKanban}
                greetingMessageInbox={lane.greetingMessageInbox}
                greetingMessageFlowBuilder={lane.greetingMessageFlowBuilder}
                greetingMessageCampaigns={lane.greetingMessageCampaigns}
                currency={currency}
                onValueChange={onValueChange}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default React.memo(KanbanBoard);
